"use client";
import { DEMO_MODE } from "@/lib/demo";

import {useEffect} from "react";

const ChatwootWidget = () => {
    useEffect(() => {
    if (DEMO_MODE) return;
        if (typeof window !== "undefined" && !document.getElementById("chatwoot-script")) {
            (function (d, t) {
                const BASE_URL = process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL;
                const TOKEN = process.env.NEXT_PUBLIC_CHATWOOT_TOKEN;

                if (!BASE_URL || !TOKEN) {
                    console.error("Chatwoot: Missing environment variables");
                    return;
                }

                const g: any = d.createElement(t),
                    s: any = d.getElementsByTagName(t)[0];
                g.id = "chatwoot-script";
                g.src = `${BASE_URL}/packs/js/sdk.js`;
                g.defer = true;
                g.async = true;
                s?.parentNode?.insertBefore(g, s);

                g.onload = () => {
                    setTimeout(() => {
                        (window as any).chatwootSDK?.run({
                            websiteToken: TOKEN,
                            baseUrl: BASE_URL,
                        });
                    }, 500);
                };
            })(document, "script");
        }
    }, []);

    return null;
};

export default ChatwootWidget;
